<div [formGroup]="form">
  <div class="section-container" id="emitente">
    <div class="section-title">
      <mat-icon>storefront</mat-icon>
      <span>Remetente</span>
    </div>
    <p class="text-muted small mb-3">Grava como Emitente da NFS-e (leiaute nacional RTC v1.01) — CNPJ/CPF nacional
      apenas.</p>

    <div class="row mb-3">
      <div class="col-12">
        <app-select-pesquisavel label="Nome" [control]="$any(form.get('idPessoa'))" [apiUrl]="urlFornecedor"
          idField="id" nameField="descricao" [isOptional]="true" hint="Pesquise pela iniciais do nome do fornecedor"
          (selectionChange)="onEmitenteSelecionado($event)">
        </app-select-pesquisavel>
        @if (form.get('idPessoa')?.hasError('required') && form.get('idPessoa')?.touched) {
        <span class="text-danger small">Selecione um fornecedor</span>
        }
      </div>
    </div>

    <div class="row">
      <div class="col-12 col-md-3">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Tipo de pessoa</mat-label>
          <mat-select formControlName="tipoPessoaEmitente">
            <mat-option [value]="tipoPessoaEnum.Juridica">Jurídica</mat-option>
            <mat-option [value]="tipoPessoaEnum.Fisica">Física</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-12 col-md-3">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>{{ docLabel }}</mat-label>
          <input matInput formControlName="identificacaoFiscal" (input)="onDocumentoInput($event)" />
        </mat-form-field>
      </div>
      <div class="col-12 col-md-3">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Inc. Municipal</mat-label>
          <input matInput formControlName="inscricaoMunicipal" />
        </mat-form-field>
      </div>
      <div class="col-12 col-md-3">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Nome Fantasia</mat-label>
          <input matInput formControlName="nomeFantasia" />
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <!-- col-md-3 (padrão do app para CEP): em col-md-2 o campo não comporta o rótulo junto
           com o botão de busca no sufixo, e o texto acaba cortado em telas médias. -->
      <div class="col-12 col-md-6 col-lg-4">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>CEP</mat-label>
          <input matInput formControlName="cep" (blur)="buscarCep()" [mask]="masks.cep" />
          <button mat-icon-button matSuffix type="button" [disabled]="isLoadingCep" (click)="buscarCep()">
            <mat-icon>search</mat-icon>
          </button>
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col-12 col-md-6">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Endereço</mat-label>
          <input matInput formControlName="logradouro" />
        </mat-form-field>
      </div>
      <div class="col-12 col-md-2">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Número</mat-label>
          <input matInput formControlName="numeroEndereco" />
        </mat-form-field>
      </div>
      <div class="col-12 col-md-4">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Complemento</mat-label>
          <input matInput formControlName="complemento" />
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col-12 col-md-4">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Bairro</mat-label>
          <input matInput formControlName="bairro" />
        </mat-form-field>
      </div>
      <div class="col-12 col-md-3">
        @if (listaUf) {
        <app-select-pesquisavel [control]="$any(form.get('uf'))" [offlineList]="listaUf" label="UF" idField="id"
          nameField="descricao" (selectionChange)="changeUnidadeFederativa($event)">
        </app-select-pesquisavel>
        }
      </div>
      <div class="col-12 col-md-5">
        <app-select-pesquisavel [control]="$any(form.get('codigoMunicipioIbge'))" [apiUrl]="urlMunicipio"
          label="Município" idField="codIbge" nameField="nome" [preloadedOptions]="preloadedCity"
          (selectionChange)="changeMunicipio($event)">
        </app-select-pesquisavel>
      </div>
    </div>

    <div class="row">
      <div class="col-12 col-md-4">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Fone</mat-label>
          <input matInput formControlName="telefone" />
        </mat-form-field>
      </div>
      <div class="col-12 col-md-8">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Email</mat-label>
          <input matInput formControlName="email" />
        </mat-form-field>
      </div>
    </div>
  </div>
</div>